import PropTypes from "prop-types";
import StatusChip from "@components/ui-components/status-chip";
import { KYC_LABEL, KYC_TONE } from "@src/utility/constants/panel/common";
import { isKycExpiringSoon, kycDaysLeft } from "../misc/kyc";

const KycStatusCell = ({ publisher }) => (
    <div className="flex items-center gap-2">
        <StatusChip tone={KYC_TONE[publisher.kyc_status] || "neutral"} label={KYC_LABEL[publisher.kyc_status] || publisher.kyc_status || "—"} />
        {isKycExpiringSoon(publisher) && (
            <span className="whitespace-nowrap text-xs font-medium text-danger">{kycDaysLeft(publisher)}d left</span>
        )}
    </div>
);

KycStatusCell.propTypes = {
    publisher: PropTypes.object.isRequired
};

export default KycStatusCell;
